export default __webpack_public_path__ + "static/media/placeholder_store01-es-web.a3f89b9f.png";